<template>
  <el-dialog :title="title"
    :visible.sync="centerDialogVisible"
    :close-on-click-modal="false"
    width="80%"
    center>
    <div class="tabs">
      <el-tabs v-model="activeSheet"
        @tab-click="handleSheetClick">
        <el-tab-pane v-for="(item, index) in sheetNames"
          :key="index"
          :label="item"
          :name="item">
        </el-tab-pane>
      </el-tabs>
      <div class="btn">
        <el-button v-if="download"
          type="primary"
          @click="handleDownload">
          <i class="gsk-icon-download"></i>
          {{$t('btn.download')}}
        </el-button>
      </div>
    </div>
    <div ref="result"
      class="excel-container"></div>
    <span slot="footer"
      class="dialog-footer">
      <el-button type="primary"
        @click="centerDialogVisible = false">{{$t('btn.confirm')}}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import XLSX from 'xlsx';

export default {
  name: 'Index',
  props: {
    data: Object || String,
    title: String,
    download: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      centerDialogVisible: false,
      sheetNames: [], // sheet 名称数组
      activeSheet: '',
      sheetContent: undefined,
      workbook: undefined
    };
  },
  methods: {
    parseExcelFile(file) {
      const reader = new FileReader();
      const that = this;
      reader.onloadend = function (event) {
        const arrayBuffer = reader.result;
        const options = { type: 'array' };
        const workbook = XLSX.read(arrayBuffer, options);
        const sheetNames = workbook.SheetNames;
        that.sheetNames = sheetNames;
        that.workbook = workbook;
        that.activeSheet = sheetNames[0];
        that.setSheetContent(that.activeSheet);
      };
      let blob;
      if (!(file instanceof Blob)) {
        blob = new Blob([file]);
      } else {
        blob = file;
      }
      try {
        reader.readAsArrayBuffer(blob);
      } catch (e) {
        this.$message.error(e);
      }
    },
    handleSheetClick(tab, event) {
      this.setSheetContent(tab.name);
    },
    setSheetContent(sheetName) {
      if (this.workbook) {
        const sheet = this.workbook.Sheets[sheetName];
        if (XLSX.utils.sheet_to_row_object_array(sheet).length) {
          const sheetContent = XLSX.utils.sheet_to_html(sheet);
          this.$refs.result.innerHTML = sheetContent;
        } else {
          this.$refs.result.innerHTML = 'No Items';
        }
      }
    },
    handleDownload() {
      this.$downloadFile(this.data, this.title);
    }
  },
  mounted: function () {
    this.$nextTick(() => {
      this.parseExcelFile(this.data);
    });
  }
};
</script>

<style lang="less" scoped>
.tabs {
  display: flex;

  .el-tabs {
    overflow: hidden;
    flex: 9;

    /deep/ .el-tabs__nav-prev,
    /deep/ .el-tabs__nav-next {
      line-height: 56px;
    }
  }

  .btn {
    flex: 1;
    margin-left: 24px;
  }
}

/deep/ .excel-container {
  background-color: #fff;
  padding: 20px;
  display: flex;
  //justify-content: center;
  max-height: 600px;
  overflow: auto;

  table {
    border-collapse: collapse;
  }

  td {
    text-align: center;
    border: 1px solid #ebeef5;
    padding: 12px;
    //word-break: initial;
    white-space: nowrap;
  }

  tr:first-child {
    font-weight: 600;
    background-color: #f6f6f6;
    color: #333;
  }

  tr:hover {
    background-color: #f6f6f6;
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?2a5a6c26